import {useCallback, useEffect, useState} from "react";

export const isTable = window.innerWidth >= 768;
export const isDesktop = window.innerWidth >= 1024;
export const isBigDesktop = window.innerWidth >= 1440;

const useWindowResize = () => {
    const [isTableState, setTableState] = useState(isTable);
    const [isDesktopState, setDesktopState] = useState(isDesktop);
    const [isBigDesktopState, setBigDesktopState] = useState(isBigDesktop);
    const [itemSize, setItemSize] = useState(0);

    function calculateSizeItem() {
        const windowWidth = window.innerWidth < window.innerHeight ? window.innerWidth : window.innerHeight / 1.3; // Получаем ширину окна браузера
        const isSmallHeight = window.innerHeight < 500;
        if (window.innerWidth >= 1440) {
            return windowWidth / 11
        }
        if (window.innerWidth >= 1024) {
            return windowWidth / 12
        }
        if (window.innerWidth >= 768) {
            return windowWidth / 13
        }
        if (isSmallHeight) {
            return windowWidth / 10
        }

        // return windowWidth / 10
        // если будет обрезаться, вернуть 10 или 9.5
        return windowWidth / 9
    }

    const handleResize = useCallback(() => {
        const size = calculateSizeItem();
        setItemSize(size);
        setDesktopState(window.innerWidth >= 768);
        setTableState(window.innerWidth >= 1024);
        setBigDesktopState(window.innerWidth >= 1440)
    }, [])

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize();

        document.addEventListener("contextmenu", (e) => e.preventDefault(), false);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isDesktopState, isTableState]);

    return {itemSize, isDesktopState, isTableState}
};

export default useWindowResize;
